export const baseHOST = 'https://api.foodsupply.de';
export const HOST = baseHOST + '/api/v1';
export const ADMINISTRATION = baseHOST + '/api/v1';
export const DATACENTER = baseHOST + '/api/datacenter/v1';
export const IMPORT = baseHOST + '/api/import/v1';
export const INSPECTION = baseHOST + '/api/inspection/v1';

export const IMPORT_ROUTE = '/import';
export const ORIGIN_ROUTE = '/origins';
export const USERS_ROUTE = '/users';

export const AUTH_ROUTE = baseHOST + '/api/login/check';
export const REFRESH_ROUTE = baseHOST + '/api/token/refresh';
